export enum OfferFormInformationKeyEnum {
  AcPartsAmortization = 'ac.partsAmortization',
  AcPartsType = 'ac.partsType',
  AssistanceMinHomeDistance = 'assistance.minHomeDistance',
}
